import { MenuItem, Select } from "@material-ui/core";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { isEmail, isEmpty } from "validator";

const MarryStatus = [
  {
    name: "Single",
    id: "Single",
  },
  {
    name: "Married",
    id: "Married",
  },
  {
    name: "Divorced",
    id: "Divorced",
  },
  {
    name: "Widowed",
    id: "Widowed",
  },
];

const BankruptcyInfo = ({
  bankruptcyInfo,
  setBankruptcyInfo,
  handleTabChange,
  errors,
  setError,
  handleSubmitBlur,
  extraFields,
  handleBackBtn,
  handleSubmitForm,
}) => {
  const currentDate = new Date();
  const minDate = new Date();
  minDate.setFullYear(currentDate.getFullYear() - 18);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const Error = { ...errors };

    // switch (name) {
    //   case "full_name":
    //     Error[name] = "";
    //     if (value.length < 1) {
    //       Error[name] = "Required";
    //       Error["disabled"] = true;
    //     } else {
    //       Error["disabled"] = true;
    //     }
    //     break;
    //   case "marital_status":
    //     Error[name] = "";
    //     if (value.length < 1) {
    //       Error[name] = "Required";
    //       Error["disabled"] = true;
    //     } else {
    //       Error["disabled"] = true;
    //     }
    //     break;

    //   case "email": {
    //     if (isEmpty(value)) {
    //       Error[name] = "Required";
    //       Error["disabled"] = true;
    //     } else if (!isEmail(value)) {
    //       Error[name] = "Invalid Email";

    //       Error["disabled"] = true;
    //     } else {
    //       Error[name] = "";
    //       Error["disabled"] = true;
    //     }
    //     break;
    //   }
    //   case "address":
    //     Error[name] = "";
    //     if (value.length < 1) {
    //       Error[name] = "Required";
    //       Error["disabled"] = true;
    //     } else {
    //       Error["disabled"] = true;
    //     }
    //     break;

    //   case "fax":
    //     Error[name] = "";
    //     if (value.length < 1) {
    //       Error[name] = "Required";
    //       Error["disabled"] = true;
    //     } else {
    //       Error["disabled"] = true;
    //     }
    //     break;

    //   case "social_security_no":
    //     Error[name] = "";
    //     if (value.length < 9) {
    //       Error[name] = "Social Security Number must contain 9 digits";
    //       Error["disabled"] = true;
    //     } else if (value.length > 9) {
    //       Error[name] = "Social Security Number must contain 9 digits";
    //       Error["disabled"] = true;
    //     } else {
    //       Error["disabled"] = true;
    //     }
    //     break;

    //   case "date_of_birth":
    //     Error[name] = "";
    //     if (value.length < 1) {
    //       Error[name] = "Required";
    //       Error["disabled"] = true;
    //     } else {
    //       Error["disabled"] = true;
    //     }
    //     break;

    //   case "name":
    //     Error[name] = "";
    //     if (value.length < 1) {
    //       Error[name] = "Required";
    //       Error["disabled"] = true;
    //     } else {
    //       Error["disabled"] = true;
    //     }
    //     break;

    //   case "age":
    //     Error[name] = "";
    //     if (value.length < 1) {
    //       Error[name] = "Required";
    //       Error["disabled"] = true;
    //     } else {
    //       Error["disabled"] = true;
    //     }
    //     break;

    //   case "relationship":
    //     Error[name] = "";
    //     if (value.length < 1) {
    //       Error[name] = "Required";
    //       Error["disabled"] = true;
    //     } else {
    //       Error["disabled"] = true;
    //     }
    //     break;

    //   default:
    //     break;
    // }
    setBankruptcyInfo((pre) => ({
      ...pre,
      [name]: value,
    }));
    setError((pre) => ({ ...pre, ...Error }));
  };

  const handlePhone = (name, phoneNumber, dialCode, validate) => {
    if (!phoneNumber || !dialCode) return false;
    const Error = { ...errors };
    switch (name) {
      case "cell_phone":
        if (!validate) {
          Error[name] = "Invalid Number";
        } else {
          Error[name] = "";
        }
        break;

      case "work_phone":
        if (!validate) {
          Error[name] = "Invalid Number";
        } else {
          Error[name] = "";
        }
        break;

      case "home_phone":
        if (!validate) {
          Error[name] = "Invalid Number";
        } else {
          Error[name] = "";
        }
        break;

      default:
        break;
    }
    setBankruptcyInfo((pre) => ({
      ...pre,
      [name]: phoneNumber,
    }));
    setError((pre) => ({ ...pre, ...Error }));
  };

  const handleRadioChange = (name, value) => {
    setBankruptcyInfo((pre) => ({ ...pre, [name]: value }));
  };

  const handleCheckChange = (name, value) => {
    if (bankruptcyInfo[name]?.includes(value)) {
      setBankruptcyInfo((pre) => ({
        ...pre,
        [name]: pre[name]?.filter((item) => {
          return item !== value;
        }),
      }));
    } else {
      setBankruptcyInfo((pre) => ({
        ...pre,
        [name]: pre[name] ? [...pre[name], value] : [value],
      }));
    }
    // handleSubmitBlur();
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setBankruptcyInfo((pre) => ({ ...pre, [name]: value }));
  };
  return (
    <div className="bg-white card-box px-4 py-3 rounded">
      <Form>
        <Row className="align-items-start">
          <Col lg="6" className="my-2">
            <label htmlFor="" className="form-label2 m-0">
              Bank Name
            </label>
            <input
              type="number"
              name="bank_name"
              value={bankruptcyInfo.bank_name}
              onChange={handleChange}
              placeholder=""
              className="form-control"
              onBlur={handleSubmitBlur}
            />
            <span className="note error_note py-2 m-0 text-danger">
              {errors.bank_name}
            </span>
          </Col>
          <Col lg="6" className="my-2">
            <label htmlFor="" className="form-label2 m-0">
              Account Number
            </label>
            <input
              type="number"
              name="account_number"
              value={bankruptcyInfo.account_number}
              onChange={handleChange}
              placeholder=""
              className="form-control"
              onBlur={handleSubmitBlur}
            />
            <span className="note error_note py-2 m-0 text-danger">
              {errors.account_number}
            </span>
          </Col>
          <Col lg="6" className="my-2">
            <label htmlFor="" className="form-label2 m-0">
              Amount
            </label>
            <input
              type="number"
              name="amount"
              value={bankruptcyInfo.amount}
              onChange={handleChange}
              placeholder=""
              className="form-control"
              onBlur={handleSubmitBlur}
            />
            <span className="note error_note py-2 m-0 text-danger">
              {errors.amount}
            </span>
          </Col>
          <Col lg="6" className="my-2 col-12 phone-input">
            <label for="" className="form-label2 m-0">
              Cell Phone
            </label>
            <PhoneInput
              country={"us"}
              value={bankruptcyInfo.cell_phone}
              placeholder="Cell phone"
              onChange={(data, country) => {
                let validateWithLength = country.format?.split(".");
                validateWithLength = validateWithLength?.length - 1;
                if (validateWithLength == data.length) {
                  handlePhone("cell_phone", data, country.dialCode, true);
                } else {
                  handlePhone("cell_phone", data, country.dialCode, false);
                }
              }}
              onBlur={handleSubmitBlur}
            />
            <span className="note error_note py-2 m-0 text-danger">
              {errors.cell_phone}
            </span>
          </Col>
          <Col lg="6" className="my-2">
            <label htmlFor="" className="form-label2 m-0">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={bankruptcyInfo.email}
              onChange={handleChange}
              placeholder=""
              className="form-control"
              onBlur={handleSubmitBlur}
            />
            <span className="note error_note py-2 m-0 text-danger">
              {errors.email}
            </span>
          </Col>
          <Col lg="6" className="my-2">
            <label htmlFor="" className="form-label2 m-0">
              Date
            </label>
            <input
              type="date"
              name="date_of_birth"
              value={bankruptcyInfo.date_of_birth}
              onChange={handleChange}
              placeholder=""
              max={minDate.toISOString().split("T")[0]}
              className="form-control"
              onBlur={handleSubmitBlur}
            />
            <span className="note error_note py-2 m-0 text-danger">
              {errors.date_of_birth}
            </span>
          </Col>

          {extraFields &&
            extraFields.length > 0 &&
            extraFields.map((item, idx) => {
              return (
                <>
                  {(item.type === "text" ||
                    item.type === "number" ||
                    item.type === "email" ||
                    item.type === "password" ||
                    item.type === "date" ||
                    item.type === "time" ||
                    item.type === "date-time-local") && (
                    <Col lg="6" className="my-2" key={idx}>
                      <label
                        htmlFor=""
                        className="form-label2 m-0 text-capitalize"
                      >
                        {item.title}
                      </label>
                      <input
                        type={item.type}
                        name={item.title.toLowerCase().split(" ").join("_")}
                        value={
                          bankruptcyInfo[
                            item.title.toLowerCase().split(" ").join("_")
                          ]
                        }
                        onChange={handleChange}
                        placeholder={item.placeholder}
                        className="form-control"
                        onBlur={handleSubmitBlur}
                      />

                      <span className="note error_note py-2 m-0 text-danger">
                        {errors[item.title.toLowerCase().split(" ").join("_")]}
                      </span>
                    </Col>
                  )}

                  {item.type === "radio" && (
                    <Col lg="6" className="my-2 dynamic-checkbox" key={idx}>
                      <label
                        htmlFor=""
                        className="form-label2 m-0 text-capitalize w-100"
                      >
                        {item.title}
                      </label>
                      {item.option &&
                        item.option.length > 0 &&
                        item.option.map((s, i) => {
                          return (
                            <>
                              <input
                                type={item.type}
                                name={item.title
                                  .toLowerCase()
                                  .split(" ")
                                  .join("_")}
                                value={
                                  bankruptcyInfo[
                                    item.title
                                      .toLowerCase()
                                      .split(" ")
                                      .join("_")
                                  ]
                                }
                                checked={
                                  bankruptcyInfo[
                                    item.title
                                      .toLowerCase()
                                      .split(" ")
                                      .join("_")
                                  ] == s.title
                                }
                                onChange={() =>
                                  handleRadioChange(
                                    item.title
                                      .toLowerCase()
                                      .split(" ")
                                      .join("_"),
                                    s.title
                                  )
                                }
                                className=""
                                onBlur={handleSubmitBlur}
                              />
                              <label
                                htmlFor=""
                                className="form-label2 m-0 text-capitalize"
                              >
                                {s.title}
                              </label>
                            </>
                          );
                        })}

                      <span className="note error_note py-2 m-0 text-danger">
                        {errors[item.title.toLowerCase().split(" ").join("_")]}
                      </span>
                    </Col>
                  )}

                  {item.type === "checkbox" && (
                    <Col lg="6" className="my-2 dynamic-checkbox" key={idx}>
                      <label
                        htmlFor=""
                        className="form-label2 m-0 text-capitalize w-100"
                      >
                        {item.title}
                      </label>
                      {item.option &&
                        item.option.length > 0 &&
                        item.option.map((s, i) => {
                          return (
                            <>
                              <input
                                type={item.type}
                                name={item.title
                                  .toLowerCase()
                                  .split(" ")
                                  .join("_")}
                                value={
                                  bankruptcyInfo[
                                    item.title
                                      .toLowerCase()
                                      .split(" ")
                                      .join("_")
                                  ]
                                }
                                checked={bankruptcyInfo[
                                  item.title.toLowerCase().split(" ").join("_")
                                ]?.includes(s.title)}
                                onChange={() =>
                                  handleCheckChange(
                                    item.title
                                      .toLowerCase()
                                      .split(" ")
                                      .join("_"),
                                    s.title
                                  )
                                }
                                className=""
                                onBlur={handleSubmitBlur}
                              />
                              <label
                                htmlFor=""
                                className="form-label2 m-0 text-capitalize"
                              >
                                {s.title}
                              </label>
                            </>
                          );
                        })}

                      <span className="note error_note py-2 m-0 text-danger">
                        {errors[item.title.toLowerCase().split(" ").join("_")]}
                      </span>
                    </Col>
                  )}

                  {item.type === "select" && (
                    <Col lg="6" className="my-2 doc-select" key={idx}>
                      <label
                        htmlFor=""
                        className="form-label2 m-0 text-capitalize w-100"
                      >
                        {item.title}
                      </label>
                      <Select
                        className="demo-simple-select-label"
                        id="demo-simple-select"
                        name={item.title.toLowerCase().split(" ").join("_")}
                        value={
                          bankruptcyInfo[
                            item.title.toLowerCase().split(" ").join("_")
                          ]
                        }
                        onBlur={handleSubmitBlur}
                        onChange={(e) =>
                          handleSelectChange(
                            e,
                            item.title.toLowerCase().split(" ").join("_")
                          )
                        }
                        MenuProps={item.option}
                      >
                        {item.option &&
                          item.option.length > 0 &&
                          item.option.map((s, i) => {
                            return (
                              <MenuItem key={s.title} value={s.title}>
                                {s.title}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors[item.title.toLowerCase().split(" ").join("_")]}
                      </span>
                    </Col>
                  )}

                  {item.type === "multiselect" && (
                    <Col lg="6" className="my-2 doc-select" key={idx}>
                      <label
                        htmlFor=""
                        className="form-label2 m-0 text-capitalize w-100"
                      >
                        {item.title}
                      </label>
                      <Select
                        className="demo-simple-select-label"
                        id="demo-simple-select"
                        name={item.title.toLowerCase().split(" ").join("_")}
                        value={
                          bankruptcyInfo[
                            item.title.toLowerCase().split(" ").join("_")
                          ]
                        }
                        onBlur={handleSubmitBlur}
                        multiple
                        onChange={(e) =>
                          handleSelectChange(
                            e,
                            item.title.toLowerCase().split(" ").join("_")
                          )
                        }
                        MenuProps={item.option}
                      >
                        {item.option &&
                          item.option.length > 0 &&
                          item.option.map((s, i) => {
                            return (
                              <MenuItem key={s.title} value={s.title}>
                                {s.title}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors[item.title.toLowerCase().split(" ").join("_")]}
                      </span>
                    </Col>
                  )}
                </>
              );
            })}

          <Col lg="12" className="my-2">
            <div className="pt-4 btn-wrp d-flex algign-items-center">
              <Button
                //   disabled={errors.disabled}
                onClick={handleSubmitForm}
                className={`d-inline-flex align-items-center justify-content-center me-2`}
              >
                Submit
              </Button>
              <Button
                //   disabled={errors.disabled}
                onClick={() => handleBackBtn("legal")}
                className={`back-form-btnn d-inline-flex align-items-center justify-content-center me-2`}
              >
                Back
              </Button>
            </div>
          </Col>
          {/* <Col lg="12" className="my-2">
            <div className="pt-4 btn-wrp d-flex algign-items-center">
              <Button
                // disabled={errors.disabled}
                onClick={() => handleTabChange("personalInfo")}
                className={`d-inline-flex align-items-center justify-content-center me-2`}
              >
                Next
              </Button>
            </div>
          </Col> */}
        </Row>
      </Form>
    </div>
  );
};

export default BankruptcyInfo;
